export default __webpack_public_path__ + "static/media/featured-item-7.e46dbfc5.png";